<div class="form-group d-flex align-items-center" *ngIf="show">
    <form-field-material-switch class="mt-3 pr-3"
                                name="legacy_enable_statistics"
                                [(ngModel)]="canUse"
                                (ngChange)="onChangeValue()">
    </form-field-material-switch>
    <label for="legacy_enable_statistics" class="font-weight-400 my-0" translate>
        Enable Statistics
    </label>
</div>
